import React from 'react';
import { ArrowUp, ArrowDown, ArrowRight, Lightbulb } from 'lucide-react';

const INK    = '#2B2620';
const WALNUT = '#8B4513';
const MOSS   = '#3B6B44';
const RUST   = '#A13D2D';
const STONE  = '#8C8275';
const PAPER  = '#FDFBF8';
const FONT_DISPLAY = "'Fraunces', Georgia, serif";
const FONT_SANS    = "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export default function LeadTimeMetric({ averageDays, trend }) {
  const trendColor = !trend ? STONE : trend > 0 ? RUST : MOSS;
  const TrendIcon   = !trend ? ArrowRight : trend > 0 ? ArrowUp : ArrowDown;

  return (
    <div style={{
      padding: '20px',
      background: PAPER,
      borderRadius: '14px',
      border: '1px solid rgba(139,69,19,0.1)',
      boxShadow: '0 2px 12px rgba(139,69,19,0.06)',
      fontFamily: FONT_SANS,
    }}>
      <h3 style={{
        fontSize: '15px',
        fontWeight: '600',
        color: INK,
        marginBottom: '16px'
      }}>
        Average Lead Time
      </h3>

      <div style={{
        display: 'flex',
        alignItems: 'baseline',
        gap: '10px',
        marginBottom: '8px'
      }}>
        <div style={{
          fontFamily: FONT_DISPLAY,
          fontSize: '44px',
          fontWeight: 600,
          color: WALNUT,
          lineHeight: 1
        }}>
          {averageDays || 0}
        </div>
        <div style={{
          fontSize: '17px',
          color: STONE,
          fontWeight: '600'
        }}>
          days
        </div>
      </div>

      <div style={{
        fontSize: '13px',
        color: STONE,
        marginBottom: '12px'
      }}>
        From sold to scheduled
      </div>

      {trend !== null && trend !== undefined && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          padding: '8px 12px',
          background: `${trendColor}12`,
          borderRadius: '8px'
        }}>
          <TrendIcon size={14} strokeWidth={2.5} color={trendColor} />
          <span style={{
            fontSize: '13px',
            fontWeight: '600',
            color: trendColor
          }}>
            {Math.abs(trend).toFixed(1)} days vs last month
          </span>
        </div>
      )}

      <div style={{
        display: 'flex', alignItems: 'flex-start', gap: '8px',
        marginTop: '16px',
        padding: '12px',
        background: 'rgba(139,69,19,0.05)',
        borderRadius: '8px',
        fontSize: '12px',
        color: STONE,
        lineHeight: '1.5',
      }}>
        <Lightbulb size={14} strokeWidth={2} color={WALNUT} style={{ flexShrink: 0, marginTop: '1px' }} />
        <span><strong style={{ color: WALNUT }}>Tip:</strong> Keep lead time under 30 days for optimal customer satisfaction</span>
      </div>
    </div>
  );
}
